<template>
  <div>
    <stockComponent :isManage="true"/>
  </div>
</template>

<script>
import stockComponent from '@/components/stock/Index'

export default {
  components: {
    stockComponent
  }
}
</script>
